import React, { useEffect, useState } from "react";
import CardMedia from "@mui/material/CardMedia";
import Skeleton from "@mui/material/Skeleton";
import { StringsService } from "../services/strings/strings";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import { Box } from "@mui/system";

interface AsyncCardMediaProps {
  imageId: string;
  alt: string | Element;
  component?: React.ElementType;
  sx?: object;
  height?: string;
  onLoad?: () => void;
}

const AsyncCardMedia: React.FC<AsyncCardMediaProps> = ({
  imageId,
  alt,
  component = "img",
  sx,
  height,
  onLoad,
}) => {
  const [imageUrl, setImageUrl] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true); // <-- Add this
  const [hasImage, setHasImage] = useState<boolean>(true); // <- new

  useEffect(() => {
    let isMounted = true;

    const fetchImage = async () => {
      setIsLoading(true);
      setHasImage(true);

      const url = await StringsService.getStringById(imageId);

      if (!url) {
        if (isMounted) {
          setIsLoading(false);
          setHasImage(false);
        }
        return;
      }

      const img = new Image();
      img.src = url;
      
      img.onload = () => {
        if (isMounted) {
          setImageUrl(url);
          setIsLoading(false);
          onLoad?.();
        }
      };

      img.onerror = () => {
        if (isMounted) {
          setIsLoading(false);
          setHasImage(false);
        }
      };
    };

    fetchImage();

    return () => {
      isMounted = false;
    };
  }, [imageId, onLoad]);

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={height}
        sx={{ borderRadius: 2,}}
      />
    );
  }

  if (!hasImage) {
    return (
      <Box
        sx={{backgroundColor: "#f0f0f0", justifyContent: "center", alignItems:"center", direction: "column", display: "flex", ...sx}}
        height={180}
      >
        <ImageNotSupportedIcon style={{ fontSize: 48, color: "#9e9e9e", alignSelf: "center" }} />
      </Box>
    );
  }
  
  return (
    <CardMedia
      component={component}
      image={imageUrl}
      alt={alt}
      sx={sx}
      height={height}
    />
  );
};

export default AsyncCardMedia;
